// Components==============
import { useRedux } from 'hooks/useRedux';
// =========================

export type StudentListEntity = {
  name: string;
  projectId: number;
  userId: number;
  membership: string;
};

export function useStudentList(theme?: ThemeEntity) {
  const userId = useRedux((state) => state.authentication?.user?.id);

  const studentList: StudentListEntity[] = [];

  const allProjects = useRedux((state) =>
    state.project?.entities.allIds
      .map((id) => state.project?.entities.byId[id])
      ?.filter(
        (p) =>
          p?.theme_id === theme?.id &&
          p?.members
            .filter(
              (m) =>
                m.membership === 'teacher' ||
                m.membership === 'extern' ||
                m.membership === 'invited' ||
                m.membership === 'admin'
            )
            .map((m) => m.user_id)
            .includes(userId || 0)
      )
  );

  allProjects?.forEach((p) => {
    if (p?.members.length)
      p.members.forEach((m) => {
        if (
          m.membership === 'teacher' ||
          m.membership === 'extern' ||
          m.membership === 'invited' ||
          m.membership === 'admin'
        )
          return;

        if (m.user)
          studentList.push({
            name: `${m.user?.first_name} ${m.user?.last_name}`,
            projectId: p?.id,
            userId: m?.user?.id,
            membership: m?.membership,
          });
      });
  });

  return studentList;
}
